import ZonesPage from "./ZonesPage";
export default ZonesPage;
